// authApi.js
import { API_CONFIG} from "../../utils/api-config";
import fetchWithAuth from "../../utils/apiAthurization";

export const GetLastPatientDischarge = async () => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/ipd/patient-discharges/get-last-patient-discharge`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "IpdBillCharges fetching failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const StorePatientDischarge = async (data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/ipd/patient-discharges`,'POST',data
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const GetPatientDischarges = async () => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/ipd/patient-discharges`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "PatientDischarges fetching failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const GetPatientDischargeById = async (id) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/ipd/patient-discharges/${id}`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const UpdatePatientDischarge = async (id,data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/ipd/patient-discharges/${id}`,'PATCH',data
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const DeletePatientDischarge = async (id) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/ipd/patient-discharges/${id}`,'DELETE'
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};